require("./EmptyLayout.css");

const EmptyLayout = ({ children }) => {
  return (
    <>
      <div className="flexible-content">
        <main id="content emptyLayout"
          style={{
            backgroundImage: 'url(background.jpg)',
            position: 'fixed',
            width: '100%',
            height: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition:'center center',
            backgroundSize:'cover',
            padding: "15px"
          }}
          className="telurmixBackground">
          {children}
        </main>
      </div>
    </>
  );
};

export default EmptyLayout;
